import { erpAxios } from '.';

const getRazlogOdbijanja = async (brojZahtjeva) => {
  const { data } = await erpAxios.get(`/statusOdbijen/razlogOdbijanja/${brojZahtjeva}`);
  return data;
};

export default getRazlogOdbijanja;
